'use client';
import useCurrentUrl from '@repo/ui/src/hooks/useCurrentUrl';
import { useMounted } from '@repo/ui/src/hooks/useMounted';
import { classNames } from '@repo/ui/src/utils/classNames';

type Type = 'inline' | 'summary';

interface Props {
  id: string;
  enableSEO?: boolean;
  type?: Type;
  dark?: boolean;
}

const attributeMap: Record<Type, string> = {
  inline: 'inline_rating',
  summary: 'rating_summary',
};

const BazaarvoiceRating = ({ id, enableSEO = true, type = 'inline', dark = false }: Props) => {
  const { enableBazaarvoice } = useCurrentUrl();
  const isMounted = useMounted();

  if (!enableBazaarvoice) return null;

  return (
    <div
      className={classNames(
        'review-it',
        dark &&
          '[&_.bv_numReviews_text]:!text-white [&_.bv_avgRating_component_container]:!text-white',
      )}
    >
      {isMounted && (
        <span data-bv-show={attributeMap[type]} data-bv-product-id={id} data-bv-seo={enableSEO} />
      )}
    </div>
  );
};

export default BazaarvoiceRating;
